export const getDropdownOptions = (dataArray, valueKey = 'id', labelKey = 'name') => {
    if (!Array.isArray(dataArray)) return [];
    return dataArray.map(item => ({
        value: item[valueKey],
        label: item[labelKey],
        code: item?.code,
    }));
};

export const getSelectedOption = (options = [], value) => {
    return options.find(option => option.value === value) || null;
}

export const getMultiSelectedOptions = (options = [], values = []) => {
    return options.filter(option => values.includes(option.value?.toString()));
}
